import type { LearnFAQ } from "@/pages/learn/learnShared";
import {
  makeEsArticle,
  esSaintRelated,
  type EsArticleInput,
} from "./learnFactoryEs";

const reviewBlock = {
  writtenBy: "Neuro Wellness TMS Centers of America",
  reviewedBy: "Daniel Pietras, MD",
  published: "November 3, 2026",
  lastReviewed: "November 3, 2026",
  lastUpdated: "November 3, 2026",
};

const faqs: LearnFAQ[] = [
  {
    question: "¿Spravato o TMS para la depresión?",
    answer:
      "Spravato (esketamina nasal) y la TMS son tratamientos distintos. Spravato está autorizado por la FDA para la depresión resistente al tratamiento y se administra en una clínica certificada con monitorización. La TMS convencional está autorizada para el trastorno depresivo mayor y suele durar seis semanas. SAINT® es TMS acelerada durante cinco días. La idoneidad se confirma mediante una evaluación psiquiátrica.",
  },
];

export const esSpravatoVsTms = makeEsArticle({
  slug: "spravato-vs-tms-for-depression",
  title: "Spravato vs TMS para la depresión",
  description:
    "Spravato (esketamina) y la TMS comparados: mecanismo, calendario, entorno de administración y estado de aprobación. SAINT® es TMS acelerada durante cinco días. La idoneidad se confirma mediante una evaluación psiquiátrica.",
  h1: "Spravato vs TMS para la depresión",
  breadcrumbLabel: "Spravato vs TMS",
  shortAnswer:
    "Spravato (esketamina nasal) y la TMS son tratamientos distintos para la depresión. Spravato está autorizado por la FDA para la depresión resistente al tratamiento y se administra en una clínica certificada con monitorización durante varias semanas. La TMS convencional está autorizada para el trastorno depresivo mayor y suele durar seis semanas. SAINT® es TMS acelerada con orientación por fMRI durante cinco días. La idoneidad se confirma mediante una evaluación psiquiátrica.",
  keyTakeaways: [
    "Spravato está autorizado por la FDA para la depresión resistente al tratamiento.",
    "Spravato se administra en una clínica certificada con monitorización.",
    "La TMS convencional suele durar seis semanas.",
    "SAINT® es TMS acelerada durante cinco días.",
    "La idoneidad se confirma mediante una evaluación psiquiátrica.",
  ],
  sections: [
    {
      heading: "Mecanismo",
      paragraphs: [
        "Spravato (esketamina) actúa como antagonista del receptor NMDA y se administra en spray nasal. La TMS utiliza campos magnéticos para estimular las neuronas en una región del cerebro asociada con el estado de ánimo.",
      ],
    },
    {
      heading: "Calendario y administración",
      paragraphs: [
        "Spravato se administra en una clínica certificada, con monitorización durante al menos dos horas después de cada dosis, en una serie de sesiones a lo largo de varias semanas. La TMS convencional suele durar seis semanas, con sesiones diarias. SAINT® comprime el tratamiento en cinco días.",
      ],
    },
    {
      heading: "¿Cuál podría ser adecuado para usted?",
      paragraphs: [
        "No hay una respuesta universal. La idoneidad depende del diagnóstico, el historial de tratamiento y otros factores. Una evaluación psiquiátrica es el primer paso. [[Solicite una consulta|/es/saint]] o llame al 954-827-9793.",
      ],
    },
  ],
  faqs,
  sources: [],
  relatedLinks: esSaintRelated,
  reviewBlock,
} satisfies EsArticleInput);
